import { Link, createFileRoute } from "@tanstack/react-router";

import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { PageHero } from "@/components/layout/PageHero";
import { heroFor } from "@/data/heroes";

const TITLE = "Thank You — Light of Life International";
const DESCRIPTION = "Thank you for partnering with Light of Life International.";

export const Route = createFileRoute("/thank-you")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://loli.ardent.dev/thank-you" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://loli.ardent.dev/thank-you" }],
  }),
  component: ThankYouPage,
});

function ThankYouPage() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />
      <PageHero title="Thank You" image={heroFor("/thank-you").image} height="short" />
      <main id="main" className="flex-1">
        <section className="section-y bg-white">
          <div className="container-site max-w-2xl text-center">
            <h2 className="text-4xl text-navy sm:text-5xl">Thank you</h2>
            <p className="mt-6 text-lg text-foreground">
              Your responses were successfully submitted.
            </p>
            <Link
              to="/"
              className="mt-10 inline-block rounded-lg bg-accent px-8 py-3 font-sans font-semibold text-navy transition hover:brightness-110"
            >
              Return to Home
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
